import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i2 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PrimengLibraryModule } from 'primeng-library';
import { BrowserModule } from '@angular/platform-browser';

class LibPdfViewerService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getPDF(listId) {
        return this.http.get(`/vd/formBuilder/client/invoice/${listId}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibPdfViewerService.ɵfac = function LibPdfViewerService_Factory(t) { return new (t || LibPdfViewerService)(i0.ɵɵinject(i1.HttpClient)); };
LibPdfViewerService.ɵprov = i0.ɵɵdefineInjectable({ token: LibPdfViewerService, factory: LibPdfViewerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPdfViewerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class LibPdfViewerComponent {
    constructor(PdfViewerService, el, renderer) {
        this.PdfViewerService = PdfViewerService;
        this.el = el;
        this.renderer = renderer;
        this.pdfSrc = null;
        this.getPDFResponse = [];
        this.showLoader = false;
    }
    ngAfterViewInit() {
        this.pdfpageFormid = sessionStorage.getItem('pageFormId');
        if (this.pdfpageFormid) {
            this.getPDF();
        }
    }
    subscribeToPrintEvent() {
        const pdfPrintButton = this.el.nativeElement.querySelector('pdf-print button');
        if (pdfPrintButton) {
            this.renderer.listen(pdfPrintButton, 'click', () => {
                this.setPrintContainerStyle();
            });
        }
    }
    setPrintContainerStyle() {
        const printContainerDiv = document.querySelector('#printContainer>div');
        if (printContainerDiv) {
            this.renderer.setStyle(printContainerDiv, 'display', 'inline');
        }
        else {
            setTimeout(() => {
                this.setPrintContainerStyle();
            }, 50);
        }
    }
    getPDF() {
        this.getListId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        this.PdfViewerService.getPDF(this.getListId).subscribe((response) => {
            if (response) {
                this.getPDFResponse = response.data || null;
                if (this.pdfpageFormid == 236) {
                    this.pdfSrc = environment.docs + this.getPDFResponse.docInvoiceLocation;
                }
                else {
                    this.pdfSrc = environment.docs + this.getPDFResponse.docReceiptLocation;
                }
            }
            this.subscribeToPrintEvent();
        });
    }
}
LibPdfViewerComponent.ɵfac = function LibPdfViewerComponent_Factory(t) { return new (t || LibPdfViewerComponent)(i0.ɵɵdirectiveInject(LibPdfViewerService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
LibPdfViewerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibPdfViewerComponent, selectors: [["lib-pdf-viewer"]], decls: 5, vars: 1, consts: [[1, "container-fluid"], [1, "row"], [1, "col-12"], [1, "pdf-container"], ["height", "80vh", "useBrowserLocale", "true", 1, "letter-pdf", 2, "width", "100%", 3, "src"]], template: function LibPdfViewerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "ngx-extended-pdf-viewer", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", ctx.pdfSrc);
    } }, directives: [i2.NgxExtendedPdfViewerComponent], styles: ["pdf-viewer[_ngcontent-%COMP%]{display:block;height:100vh}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPdfViewerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-pdf-viewer',
                templateUrl: "./lib-pdf-viewer.component.html",
                styleUrls: ["./lib-pdf-viewer.component.scss"],
            }]
    }], function () { return [{ type: LibPdfViewerService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, null); })();

class LibPdfViewerModule {
}
LibPdfViewerModule.ɵfac = function LibPdfViewerModule_Factory(t) { return new (t || LibPdfViewerModule)(); };
LibPdfViewerModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibPdfViewerModule });
LibPdfViewerModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            BrowserModule,
            PdfViewerModule,
            NgxExtendedPdfViewerModule,
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibPdfViewerModule, { declarations: [LibPdfViewerComponent], imports: [BrowserModule,
        PdfViewerModule,
        NgxExtendedPdfViewerModule,
        PrimengLibraryModule], exports: [LibPdfViewerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPdfViewerModule, [{
        type: NgModule,
        args: [{
                declarations: [LibPdfViewerComponent],
                imports: [
                    BrowserModule,
                    PdfViewerModule,
                    NgxExtendedPdfViewerModule,
                    PrimengLibraryModule,
                ],
                exports: [LibPdfViewerComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-pdf-viewer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibPdfViewerComponent, LibPdfViewerModule, LibPdfViewerService };
//# sourceMappingURL=lib-pdf-viewer.js.map
